var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.0898C15.93 15.0898 15.42 15.3148 15.03 15.6673L9.6825 12.5548C9.72 12.3823 9.75 12.2098 9.75 12.0298C9.75 11.8498 9.72 11.6773 9.6825 11.5048L14.97 8.42229C15.375 8.79729 15.9075 9.02979 16.5 9.02979C17.745 9.02979 18.75 8.02479 18.75 6.77979C18.75 5.53479 17.745 4.52979 16.5 4.52979C15.255 4.52979 14.25 5.53479 14.25 6.77979C14.25 6.95979 14.28 7.13229 14.3175 7.30479L9.03 10.3873C8.625 10.0123 8.0925 9.77979 7.5 9.77979C6.255 9.77979 5.25 10.7848 5.25 12.0298C5.25 13.2748 6.255 14.2798 7.5 14.2798C8.0925 14.2798 8.625 14.0473 9.03 13.6723L14.37 16.7923C14.3325 16.9498 14.31 17.1148 14.31 17.2798C14.31 18.4873 15.2925 19.4698 16.5 19.4698C17.7075 19.4698 18.69 18.4873 18.69 17.2798C18.69 16.0723 17.7075 15.0898 16.5 15.0898Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3c8c78fc9c88fc405dfff35eae76bebc.svg";
export { ForwardRef as ReactComponent };